export default __webpack_public_path__ + "static/media/EagleViewLogo.b335eec4.svg";